import { useLatestDealsCompleted } from '../../../query-hooks/latest-deals-completed';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
type RawItem = ReturnType<typeof useLatestDealsCompleted>['data']['results'][0];

export function transformItem(item: RawItem) {
  const {
    price,
    address,
    buildYear,
    rooms,
    floor,
    buildingMR,
    propertyType,
    saleDate,
  } = item;

  return {
    price,
    address: {
      city: address.city?.text,
      street: address.street.text,
      houseNumber: address.houseNumber,
      addressMasterId: address.addressMasterId,
    },
    buildYear,
    rooms,
    floor,
    buildingMR,
    propertyType,
    saleDate: new Date(saleDate),
  };
}

export type CompletedDealItem = ReturnType<typeof transformItem>;
